import { useState } from "react";
import { OrderDetailItem, OrderSplitResultItem } from "../../interfaces/interfaces";
import { sortProducts } from "../../pages/order-uploader/utils/productUtils";
import CartItem from "../CartItem/CartItem";
import Tooltip from "../Tooltip/Tooltip";
import { FetchedOrderUploadProduct } from "../../pages/order-uploader/types";

interface Props {
  items: OrderSplitResultItem[] | OrderDetailItem[] | FetchedOrderUploadProduct[];
  action?: boolean;
  showStock?: boolean;
  showIndex?: boolean;
  checkout?: boolean;
  bo?: boolean;
  split?: boolean;
  disableAvailableQty?: boolean;
  disableTotal?: boolean;
  hideDetailsButton?: boolean;
  qtyColumn?: boolean;
}

interface Sort {
  ascending: boolean;
  type: "index" | "stock" | "b/o" | "none";
}

const CartItemTable = (props: Props) => {
  const {
    items,
    action,
    showStock,
    showIndex,
    checkout,
    bo,
    split,
    disableAvailableQty,
    disableTotal,
    hideDetailsButton,
    qtyColumn,
  } = props;
  const [sort, setSort] = useState<Sort>({ ascending: true, type: "none" });

  if (!items?.length) return null;

  const sortedItems = sortProducts(items.slice() as FetchedOrderUploadProduct[], sort);

  return (
    <table className="cart-item-table cart-item-table--collapsible">
      <tbody>
        <tr className="cart-item-table__header">
          {!qtyColumn && <th className="expand-column" />}
          <th className="description">Description</th>
          <th className="color-column">Colour</th>
          <th className="size-column">Size</th>
          {qtyColumn && <th className="qty-column">Qty</th>}
          {bo && <th className="bo-column">B/O</th>}
          {!disableAvailableQty && (
            <th className="available-column">
              <Tooltip
                content="Units currently in stock and ready to ship. Used to calculate the Total."
                tooltipClassName="tooltip"
              >
                Available Qty
              </Tooltip>
            </th>
          )}
          <th className="price-column">Price</th>
          {!disableTotal && <th className="total-column">Total</th>}
          {action && <th className="actions-column" />}
        </tr>
        {sortedItems.map((product, index) => (
          <CartItem
            key={index}
            item={product}
            action={action}
            bo={bo}
            split={split}
            showStock={showStock}
            disableAvailableQty={disableAvailableQty}
            disableTotal={disableTotal}
            index={showIndex && product.index && `${parseInt(product.index) + 1}`}
            checkout={checkout}
            hideDetailsButton={hideDetailsButton}
            qtyColumn={qtyColumn}
            sort={sort}
            onSort={setSort}
          />
        ))}
      </tbody>
    </table>
  );
};

export default CartItemTable;
